<div class="dialog-content">
    <span class="cta" aria-live="assertive" role="alert">{{ message }}</span>
</div>
